<template>
  <div class="integral-rule">

    <div class="top">
      <el-button
        size="text"
        icon="el-icon-arrow-left"
        class="but-black"
        @click="closeEdit"
      >
        返 回
      </el-button>
      <el-button
        class="el-icon-check but-add-type"
        @click="saveAll"
      >
        保存
      </el-button>
    </div>

    <!-- 删除类型提示 -->
    <el-dialog
      title="确认要删除此项吗？"
      :visible.sync="delDialogVisible"
      width="40%"
      :append-to-body="true"
    >
      <span slot="footer">
        <el-button
          size="small"
          @click="delDialogVisible = false"
        >
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="delSelect"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 树形控件 -->
    <!-- <div v-for="(treeData,index) in treeDataList" :index="index" :key="index"> -->
    <div class="tree-box">
      <el-card>
        <div class="ly-tree-container">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent"
          >
          </el-tree>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { delItem, addItem, updateItem } from "../../../../utils/tree/tree.api";
import {
  getEditContent,
  getDefaultContent,
} from "../../../../utils/tree/tree.utils.js";
import { toChinesNum } from "../../../../utils/tree/numToChines.js";
import { mapState } from "vuex";

import "./tree.less";

export default {
  name: "ly-tree",
  props: {
    isAddMenu: {
      //新增菜单进来的
      type: Boolean,
      default: false,
    },
    addMenuObj: Object,
    selectRow: Object,
  },
  computed: {
    ...mapState(["userInfo", "scoreMenuList"]),
  },
  data() {
    return {
      treeData: [],
      // treeDataList:[],
      isEdit: false,
      edit_name: "",
      edit_score: null,
      edit_levelname: "",

      is_superuser: "False",
      defaultProps: {
        children: "child",
        label: "integralName",
      },
      select_id: null,
      select_level: null,
      select_node: null,
      delDialogVisible: false,
    };
  },

  created() {
    this.refresh();
  },

  methods: {
    refresh() {
      if (this.isAddMenu) {
        //新增菜单进来的
        this.treeData = [];
        this.treeData = [
          {
            levelname: "菜单",
            integralName: this.addMenuObj.menuName,
            integralCode: this.addMenuObj.menuCode,
            integralModel: this.addMenuObj.menuCode,
            integralNum: 0,
            integralLevel: 0,
            isNodeEdit: false,
            child: [],
          },
        ];
      } else {
        //编辑 进来的
        this.selectIn();
      }
    },
    selectIn() {
      let selectForm = {
        integralModel:
          this.selectRow.integralModel || this.treeData[0].integralModel,
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
      };
      this.$axios
        .post(
          "/integralRule/getTeacherIntegralRule",
          this.$qs.stringify(selectForm)
        )
        .then((res) => {
          if (res.resultCode === 200) {
            this.handleSelctData(res.data);
          } else {
            console.log("查询积分规则else", res);
          }
        })
        .catch((err) => {
          console.log("查询积分规则error", err);
        });
    },
    handleSelctData(resData) {
      let menuHandleObj = this.scoreMenuList.find(
        (item) => item.menuCode === resData.integralModel
      );
      resData.integralName = menuHandleObj.menuName;
      resData.integralLevel = 0;
      resData.integralCode = resData.integralModel;
      resData.integralNum = 0;
      resData.levelname = "菜单";
      //递归增加层级名称
      this.recursion(resData.child);
      this.treeData = [];
      this.treeData.push(resData);
    },
    saveAll() {
      if (this.isEdit) {
        this.$message({
          message: "您有未编辑完成的选项 ！",
          type: "warning",
          duration: 4000,
          offset: 150,
        });
        return;
      }
      let copyTree = this.deepCopy(this.treeData);
      this.delFormPros(copyTree);
      copyTree[0].operatorId = this.userInfo.userId;
      copyTree[0].clientPackage = "com.xueduoduo.teacher.archives.pc";
      copyTree[0].schoolCode = this.userInfo.schoolCode;

      let postForm = copyTree[0];

      if (!this.isAddMenu) {
        //更新   根据integralCode 进行更新，，所以新增的规则不能有integralCode
        this.$axios
          .post("/integralRule/updateTeacherIntegralRule", postForm)
          .then((res) => {
            if (res.resultCode === 200) {
              this.$message({
                message: "更新成功",
                type: "success",
                duration: 2000,
                offset: 150,
              });
              this.closeEdit();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
                duration: 2000,
                offset: 150,
              });
            }
          })
          .catch((err) => {
            console.log("积分规则更新error", err);
          });
      } else {
        //新增
        this.$axios
          .post("/integralRule/saveTeacherIntegralRule", postForm)
          .then((res) => {
            if (res.resultCode === 200) {
              this.$message({
                message: "新增成功",
                type: "success",
                duration: 2000,
                offset: 150,
              });
              this.closeEdit();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
                duration: 2000,
                offset: 150,
              });
            }
          })
          .catch((err) => {
            console.log("积分规则保存error", err);
          });
      }
    },
    deepCopy(obj) {
      let result = Array.isArray(obj) ? [] : {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
    delFormPros(item) {
      item.forEach((i) => {
        //新增的integralCode 为数字类型，删除掉
        if (!isNaN(Number(i.integralCode))) {
          delete i.integralCode;
        }
        delete i.integralLevel;
        delete i.levelname;
        if (i.child && i.child.length > 0) {
          this.delFormPros(i.child);
        }
      });
    },

    recursion(childList) {
      if (childList.length > 0) {
        childList.forEach((item) => {
          if (item.integralLevel === 0) {
            item.levelname = "菜单";
          } else if (item.integralLevel === 1) {
            item.levelname = "类型";
          } else {
            item.levelname = toChinesNum(item.integralLevel - 1) + "级";
          }
          if (item.child && item.child.length > 0) {
            this.recursion(item.child);
          }
        });
      }
    },
    closeEdit() {
      this.treeData = [];
      this.$emit("closeEdit");
    },

    renderContent(h, { node, data }) {
      // console.log("renderContent--node", node);
      // console.log("renderContent--data", data);
      return (
        <span class="ly-tree-node">
          {(this.isEdit === true && this.isSelect(data)) || data.isNodeEdit ? (
            <span>
              {this.edit_levelname}：
              <input
                placeholder="请输入类型名称"
                class="ly-edit__text"
                on-keyup={() => this.nameChange()}
                value={this.edit_name}
              />
              <span v-show={node.childNodes.length === 0}>
                积分：
                <input
                  placeholder="请输入积分"
                  class="ly-edit__jf"
                  on-keyup={() => this.scoreChange()}
                  value={this.edit_score}
                />
              </span>
            </span>
          ) : (
            <span>
              {data.levelname}：<span>{data.integralName}</span>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <span
                v-show={node.childNodes.length === 0 && data.integralLevel > 0}
              >
                积分：<span>{data.integralNum}</span>
              </span>
            </span>
          )}
          {(this.isEdit === true && this.isSelect(data)) || data.isNodeEdit
            ? getEditContent.call(this, h, data, node)
            : getDefaultContent.call(this, h, data, node)}
        </span>
      );
    },
    // 增加下一级按钮
    append(node, data, e) {
      e = event || window.event;
      e.stopPropagation();
      if (!this.isEdit) {
        this.select_id = data.integralCode;
        this.edit_name = "";
        this.edit_score = "0";
        if (data.integralLevel === 0) {
          this.edit_levelname = "类型";
        } else {
          this.edit_levelname = toChinesNum(data.integralLevel) + "级";
        }
        const newChild = {
          integralName: "",
          integralNum: 0,
          integralLevel: data.integralLevel + 1,
          levelname: toChinesNum(data.integralLevel + 1) + "级",
          isNodeEdit: true,
        };
        this.isEdit = true;
        //没有child属性加上
        if (!data.child) {
          this.$set(data, "child", []);
        }
        //显示的没有数据的输入框
        data.child.unshift(newChild);
      } else {
        this.$notify({
          type: "error",
          title: "操作提示",
          message: "有正在编辑或添加的选项未完成！",
          duration: 2000,
        });
      }
    },
    // 新增或者编辑 的 确认按钮
    editMsg(data, node, e) {
      e = event || window.event;
      e.stopPropagation();
      // 效验存在 名称 和 积分 才可以保存
      if (
        this.edit_name.replace(/^\s+|\s+$/g, "") &&
        this.edit_score + "".replace(/^\s+|\s+$/g, "") &&
        this.edit_score != "-"
      ) {
        //新增的不存在id integralCode)
        if (!data.integralCode) {
          let virtualNode = node.parent;

          let params = {
            integralCode: virtualNode.data.integralCode,
            integralName: this.edit_name,
            integralNum: this.edit_score,
            levelname: this.edit_levelname,
          };
          // let addChild = addItem(this.treeData, params)
          addItem(this.treeData, params);
          // 如果是用的真api,需要在添加的接口返回添加的节点
          // 添加成功后，将返回的节点加入数据中，然后删除掉没有id的假节点
          virtualNode.data.child.forEach((item, i) => {
            if (!item.integralCode) {
              virtualNode.data.child.splice(i, 1);
            }
          });
          this.isEdit = false;
          this.select_id = null;
          this.select_level = null;
          // this.$notify({
          //   type: "success",
          //   title: "操作提示",
          //   message: "添加成功！",
          //   duration: 2000,
          // });
          return;
        }

        //编辑后的确定
        let params = {
          integralName: this.edit_name,
          integralNum: this.edit_score,
          levelname: this.edit_levelname,
          integralCode: data.integralCode,
        };
        updateItem(this.treeData, params);
        this.isEdit = false;
        this.select_id = null;
        this.select_level = null;
        // this.$notify({
        //   type: "success",
        //   title: "操作提示",
        //   message: "编辑成功！",
        //   duration: 2000,
        // });
      } else {
        this.$notify({
          type: "error",
          title: "操作提示",
          message: "有正在编辑或添加的选项未完成！",
          duration: 2000,
        });
      }
    },
    //删除按钮
    remove(node, data, e) {
      e = event || window.event;
      e.stopPropagation();
      if (this.isEdit) {
        this.$notify({
          type: "error",
          title: "操作提示",
          message: "有正在编辑或添加的选项未完成！",
          duration: 2000,
        });
        return;
      }
      this.select_node = node;
      this.delDialogVisible = true;
    },

    // 删除框确认
    delSelect() {
      delItem(this.treeData, {
        integralCode: this.select_node.data.integralCode,
      });
      this.delDialogVisible = false;
      this.$notify({
        type: "success",
        title: "操作提示",
        message: "删除成功!",
        duration: 2000,
      });
    },
    //编辑按钮
    update(node, data, e) {
      e = event || window.event;
      e.stopPropagation();
      if (this.isEdit) {
        this.$notify({
          type: "error",
          title: "操作提示",
          message: "有正在编辑或添加的选项未完成！",
          duration: 2000,
        });
        return;
      }
      this.select_id = data.integralCode;
      this.select_level = data.integralLevel;
      this.edit_name = data.integralName;
      this.edit_score = data.integralNum;
      this.edit_levelname = data.levelname;
      this.isEdit = true;
    },
    //关闭编辑 按钮 取消
    close(data, node, e) {
      e = event || window.event;
      e.stopPropagation();
      if (!data.integralCode) {
        node.parent.data.child.forEach((item, i) => {
          if (!item.integralCode) {
            node.parent.data.child.splice(i, 1);
          }
        });
      }
      this.select_id = null;
      this.select_level = null;
      this.edit_name = data.integralName;
      this.isEdit = false;
    },

    nameChange(e) {
      e = event || window.event;
      e.stopPropagation();
      this.edit_name = e.target.value.replace(/\s+/g,"");//去空格
    },
    scoreChange(e) {
      e = event || window.event;
      e.stopPropagation();
      var t = e.target.value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      e.target.value = e.target.value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 只能输入一个小数
      e.target.value = e.target.value.replace(/^(-)*(\d+)\.(\d).*$/, "$1$2.$3");
      // 如果没有小数点，首位不能为类似于 01、02的金额
      if (e.target.value.indexOf(".") < 0 && e.target.value !== "") {
        e.target.value = parseFloat(e.target.value);
      }
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == "-") {
        e.target.value = "-" + e.target.value;
      }
      this.edit_score = e.target.value;
    },

    isSelect(data) {
      return (
        data.integralCode === this.select_id &&
        data.integralLevel === this.select_level
      );
    },
  },
};
</script>

<style lang="less">
.integral-rule {
  background: #ffffff;
  border-radius: 10px;
  .top {
    border-radius: 10px;
    background: #ffffff;
    width: 100%;
    height: 60px;
    line-height: 80px;
    padding: 0px 42px;
    box-sizing: border-box;
    .but-add-type {
      margin-top: 15px;
      float: right;
      color: #fff;
      background-color: @theme-color;
    }
  }
  .tree-box {
    padding: 30px;
    // padding-bottom: 0px ;
    .el-card.is-always-shadow,
    .el-card.is-hover-shadow:focus,
    .el-card.is-hover-shadow:hover {
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    /deep/.el-card {
      border: 0px;
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
